import DealerCallbackForm from "./dealer-callback-form.js";

export default class DealerCallbackRequestForm {
  constructor() {
    this._handleSuccessResponse = this._handleSuccessResponse.bind(this);
    this._handleErrorResponse = this._handleErrorResponse.bind(this);
    this._handleRequestCallbackFormSubmit = this._handleRequestCallbackFormSubmit.bind(
      this
    );
  }

  init(dealerCallbackForm) {
    this.form = dealerCallbackForm;
    this.form.addEventListener("submit", this._handleRequestCallbackFormSubmit);
  }

  _handleRequestCallbackFormSubmit(evt) {
    evt.preventDefault();

    let url = evt.target.action;
    let method = evt.target.method;
    let dataPayload = {
      NetworkId: evt.target.NetworkId.value,
      EnquiryLocation: evt.target.EnquiryLocation.value,
      PageSource: evt.target.PageSource.value,
      GtsSaleId: evt.target.GtsSaleId.value,
      RankingType: evt.target.RankingType.value,
      IsGc: evt.target.IsGc.value
    };

    $.ajax({
      url: url,
      method: method,
      dataType: "json",
      data: dataPayload
    })
      .done(this._handleSuccessResponse)
      .fail(this._handleErrorResponse);

    return false;
  }

  _handleSuccessResponse(response) {
    let targetElement = this.form.getAttribute("data-replace-to");
    let dealerCallbackForm = $(response.contentHtml);
    new DealerCallbackForm().init(dealerCallbackForm);
    $(this.form)
      .parents(targetElement)
      .empty()
      .append(dealerCallbackForm);

    $(targetElement + " .csn-control").each(function() {
      var $this = $(this);
      if ($this.val()) {
        $this
          .addClass("active")
          .next("label")
          .addClass("active");
      }
    });

    $.validator.unobtrusive.parse(document);
  }

  _handleErrorResponse(error) {
    console.log(error);
  }
}
